import React from "react";
import { useTheme } from "@material-ui/core/styles";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Label,
  ResponsiveContainer,
} from "recharts";
import Title from "./Title";
import { useProjet } from "../Contexts/projet";
import { Typography } from "@material-ui/core";

export default function TasksChart() {
  const theme = useTheme();
  const { timelogs, getTime } = useProjet();

  return (
    <>
      <React.Fragment>
        <Title>
          Nombre d'heure(s) travaillée(s):{" "}
          <Typography component="span" variant="h4">
            {getTime()}
          </Typography>
          h
        </Title>
        <ResponsiveContainer>
          <LineChart
            data={timelogs.map((timelog) => {
              return {
                time: timelog.trackedDate.substr(
                  timelog.trackedDate.length - 2
                ),
                hours: timelog.hours,
              };
            })}
            margin={{
              top: 16,
              right: 16,
              bottom: 16,
              left: 16,
            }}
          >
            <XAxis dataKey="time" stroke={theme.palette.text.secondary}>
              <Label
                angle={0}
                position="bottom"
                style={{
                  textAnchor: "middle",
                  fill: theme.palette.text.primary,
                }}
              >
                Jours du mois
              </Label>
            </XAxis>
            <YAxis stroke={theme.palette.text.secondary}>
              <Label
                angle={270}
                position="left"
                style={{
                  textAnchor: "middle",
                  fill: theme.palette.text.primary,
                }}
              >
                Heures
              </Label>
            </YAxis>
            <Line
              type="monotone"
              dataKey="hours"
              stroke={theme.palette.primary.main}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </React.Fragment>
    </>
  );
}
